export enum OFFER_STATUSES {
  ONGOING = 1,
  LOST,
  WON,
  CANCELLED,
  ORDER_CANCELLED,
  ORDER_EDITED,
}
